import TransferIssueModal from '@/components/TransferIssueModal';
import { RootState } from '@/index';
import { CLSTAG, CockpitMode, IssueStatus, IssueType } from '@/utils/constant';
import { clstagStr } from '@/utils/util';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
const TransferIssue = (props: {
  vehicleName: string;
  disabled: boolean;
  closeDropdown: () => void;
}) => {
  const { vehicleName, disabled, closeDropdown } = props;
  const [open, setOpen] = useState(false);
  const { cockpitMode } = useSelector((state: RootState) => state.cockpitInfo);
  const { issueList } = useSelector((state: RootState) => state.workOrder);
  const issueInfo =
    issueList &&
    issueList.find((workOrder: any) => {
      return (
        workOrder.vehicleName === vehicleName &&
        workOrder.issueType === IssueType.OPS
      );
    });
  const usable =
    (issueInfo?.issueStatus === IssueStatus.PROCESS ||
      issueInfo?.issueStatus === IssueStatus.ON_HOLD) &&
    cockpitMode !== CockpitMode.MONITOR &&
    !disabled &&
    issueInfo?.issueType !== IssueType.PROBLEM_REPORT;

  return (
    <>
      <button
        className="issue-command-btn"
        disabled={!usable}
        onClick={() => {
          usable && setOpen(true);
          closeDropdown();
        }}
        clstag={clstagStr(CLSTAG.TransferIssue)}
      >
        转单
      </button>

      <TransferIssueModal
        open={open}
        setOpen={setOpen}
        vehicleName={vehicleName}
        type="TRANSFER"
      />
    </>
  );
};
export default React.memo(TransferIssue);
